<div class="credit_purchase__popup">
    <div class="modal-header">
        <div class="modal-title">
            Credit purchase
        </div>

        <button id="credit-purchase-close" type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true"></span>
        </button>
    </div>

    <div class="modal-body p-4">
        <div class="row offer__text text-center mb-3">
            <div class="col-md-12">
                <!-- How Valzy credits work -->
                How Valzy Report Work
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-md-8 small__text">
                Credit is the unit in the system that can be used for 2 options:
                <ul>
                    <li>get the final value for a new report</li>
                    <li>edit the existing report (you have opportunity to edit your report for free for 3 days after
                        getting final valuation</li>
                </ul>
                <!-- Buy many credits at once, no worries, they are valid forever. -->
            </div>
        </div>

    </div>
    <div class="modal-footer">

        <div class="w-50 d-flex">
            <div class="w-75 summary-details summary-amount">
                <div class="font-weight-bold">Summary amount</div>
            </div>
            <div class="w-25 font-weight-bold summary-amount">
                ${{currencyPipe.transform(getTotalAmount() || 0)}}
            </div>
        </div>
        <div class="w-50">
            <button type="button" class="button primary__button"  id="credit-purchase-checkout" (click)="gotoBillingPage()"
                [disabled]="credit < 1">Proceed to checkout</button>
        </div>

    </div>
</div>